// extracted by mini-css-extract-plugin
export var banner = "_3s-0";
export var icon = "_3s-1";
export var message = "_3s-2";